/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { CustomerImportRequestToJSON, CustomerWithReservationDtoGenericApiResponseFromJSON, EmployeeCreateUpdateDtoGenericApiResponseFromJSON, NotificationRecurringTestRequestToJSON, ReservationDetailDtoGenericApiResponseFromJSON, } from '../models';
/**
 *
 */
export class PopulateDataApi extends runtime.BaseAPI {
    /**
     */
    apiPopulateDataAddTestNotificationPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.userEmail !== undefined) {
                queryParameters['userEmail'] = requestParameters.userEmail;
            }
            if (requestParameters.type !== undefined) {
                queryParameters['type'] = requestParameters.type;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/AddTestNotification`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataAddTestNotificationPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPopulateDataAddTestNotificationPostRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiPopulateDataAddTestRecurringNotificationPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.userEmail !== undefined) {
                queryParameters['userEmail'] = requestParameters.userEmail;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/PopulateData/AddTestRecurringNotification`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: NotificationRecurringTestRequestToJSON(requestParameters.notificationRecurringTestRequest),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataAddTestRecurringNotificationPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPopulateDataAddTestRecurringNotificationPostRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiPopulateDataCustomerimportPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/PopulateData/customerimport`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CustomerImportRequestToJSON(requestParameters.customerImportRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataCustomerimportPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPopulateDataCustomerimportPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiPopulateDataCustomerwithreservationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/customerwithreservation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CustomerWithReservationDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPopulateDataCustomerwithreservationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPopulateDataCustomerwithreservationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiPopulateDataDbdateGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/dbdate`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataDbdateGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPopulateDataDbdateGetRaw(initOverrides);
        });
    }
    /**
     */
    apiPopulateDataEmployeeGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.username !== undefined) {
                queryParameters['username'] = requestParameters.username;
            }
            if (requestParameters.password !== undefined) {
                queryParameters['password'] = requestParameters.password;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/employee`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => EmployeeCreateUpdateDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPopulateDataEmployeeGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPopulateDataEmployeeGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiPopulateDataGeneratepdfGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/generatepdf`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataGeneratepdfGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPopulateDataGeneratepdfGetRaw(initOverrides);
        });
    }
    /**
     */
    apiPopulateDataGeneratepdfPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/PopulateData/generatepdf`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataGeneratepdfPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPopulateDataGeneratepdfPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiPopulateDataRemoveprotocolsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/removeprotocols`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataRemoveprotocolsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPopulateDataRemoveprotocolsGetRaw(initOverrides);
        });
    }
    /**
     */
    apiPopulateDataRemovereservationsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/removereservations`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataRemovereservationsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPopulateDataRemovereservationsGetRaw(initOverrides);
        });
    }
    /**
     */
    apiPopulateDataReservationGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.customerId !== undefined) {
                queryParameters['customerId'] = requestParameters.customerId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/reservation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ReservationDetailDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPopulateDataReservationGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPopulateDataReservationGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiPopulateDataSendRangeTestTextMessagesGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.phoneNumbers) {
                queryParameters['phoneNumbers'] = requestParameters.phoneNumbers;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/SendRangeTestTextMessages`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataSendRangeTestTextMessagesGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPopulateDataSendRangeTestTextMessagesGetRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiPopulateDataSendTestTextMessagePhoneNumberGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.phoneNumber === null || requestParameters.phoneNumber === undefined) {
                throw new runtime.RequiredError('phoneNumber', 'Required parameter requestParameters.phoneNumber was null or undefined when calling apiPopulateDataSendTestTextMessagePhoneNumberGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/SendTestTextMessage/{phoneNumber}`.replace(`{${"phoneNumber"}}`, encodeURIComponent(String(requestParameters.phoneNumber))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataSendTestTextMessagePhoneNumberGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPopulateDataSendTestTextMessagePhoneNumberGetRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiPopulateDataServicereservationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/servicereservation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ReservationDetailDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPopulateDataServicereservationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPopulateDataServicereservationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiPopulateDataTestEmailGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.email !== undefined) {
                queryParameters['email'] = requestParameters.email;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/testEmail`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataTestEmailGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPopulateDataTestEmailGetRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiPopulateDataTimezoneGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/PopulateData/timezone`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPopulateDataTimezoneGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPopulateDataTimezoneGetRaw(initOverrides);
        });
    }
}
